document.addEventListener("DOMContentLoaded", function () {
  const sticky = document.querySelector("product-sticky-bar");
  const form = document.querySelector("form[action*='/cart/add']");
  const addToCart = document.querySelector('button[name="add"], buy-buttons button[type="submit"]');

  if (addToCart) {
    addToCart.textContent = "Select Size";
  }

  if (sticky && form) {
    const cta = form.querySelector(".buy-buttons") || form;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove("is-visible");
        } else {
          sticky.classList.add("is-visible");
        }
      },
      {
        rootMargin: "-80px 0px 0px 0px"
      }
    );

    observer.observe(cta);

    const footer = document.querySelector(".shopify-section--footer");

    if (footer) {
      const footerObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove("is-visible");
        }
      });

      footerObserver.observe(footer);
    }
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest('[data-option-value], .block-swatch, .variant-option, label, input[type="radio"]')) {
      const addToCartButton = document.querySelector('button[name="add"], buy-buttons button[type="submit"]');

      if (addToCartButton) {
        addToCartButton.textContent = "Add to Cart";
      }
    }
  });
});